// Única función de "lo que recibes" (P3, P4, P5, D1). Solo para MOSTRAR: el cobro real no se toca.
// Lee tramos, mínimo y % de Payphone de la config real (/config/public ← /admin/config).
// mode "direct": compra directa (mínimo por unidad, el neto más bajo) · "cart": mínimo una vez por vendedor.
const r2 = (x) => Math.round((Number(x) + Number.EPSILON) * 100) / 100;
const tierFor = (p, tiers) => (tiers || []).find((t) => t.max === null || t.max === undefined || p <= t.max);

export function sellerNet(lines, ship, method, cfg, mode = "direct") {
  const tiers = cfg?.commission_tiers || [];
  const ppPct = Number(cfg?.processing_pct ?? 5.75);
  let subtotal = 0, commission = 0, pct = null;
  for (const l of lines) {
    const p = Number(l.price) || 0;
    const q = Math.max(1, parseInt(l.quantity, 10) || 1);
    const t = tierFor(p, tiers);
    const tp = t ? t.pct : 10;
    pct = pct ?? tp;
    const unit = mode === "direct" ? r2(Math.max(p * tp / 100, t?.min_fee || 0)) : r2(p * tp / 100);
    subtotal += r2(p * q);
    commission += r2(unit * q);
  }
  subtotal = r2(subtotal);
  commission = r2(commission);
  if (mode === "cart") commission = r2(Math.max(commission, Number(tiers[0]?.min_fee ?? 0.30)));
  const s = Number(ship) || 0;
  const payphone = method === "card" ? r2((subtotal + s) * ppPct / 100) : 0;
  return { subtotal, commission, payphone, pct, ppPct, ship: s, net: r2(subtotal + s - commission - payphone) };
}

// ¿El perfil tiene tarifas? (sin tarifas → "Configura tu envío" en vez de "+ envío $0.00").
export function hasShipRates(cfg) {
  if (!cfg || !Object.keys(cfg).length) return false;
  if (cfg.mode === "meetup_only") return true;
  if (cfg.mode === "detailed") return Object.keys(cfg.per_province_rates || {}).length > 0;
  return cfg.same_province_rate != null || cfg.other_province_rate != null;
}

// Rango de envío del perfil del vendedor (mismas reglas que compute_ship_for del backend).
export function shipRange(cfg) {
  if (!cfg || !Object.keys(cfg).length) return [5, 5];
  if (cfg.mode === "meetup_only") return [0, 0];
  if (cfg.mode !== "detailed") {
    const a = Number(cfg.same_province_rate || 0), b = Number(cfg.other_province_rate || 0);
    return [Math.min(a, b), Math.max(a, b)];
  }
  const rates = Object.values(cfg.per_province_rates || {}).map(Number).filter((n) => !isNaN(n));
  return rates.length ? [Math.min(...rates), Math.max(...rates)] : [5, 5];
}
